exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1d1KTZykDYjTsJ{color:#5e6c84;text-align:center;padding:8px}._2Ctpnw5Gy95iso{width:400px;background-color:#fff;padding:24px;border-radius:3px}._2Ctpnw5Gy95iso p{margin-top:20px}._2Ctpnw5Gy95iso ul{margin-top:20px;padding-left:1em;list-style:outside}._2Ctpnw5Gy95iso li{margin-top:12px}._2Ctpnw5Gy95iso li:first-child{margin-top:0}._2Ctpnw5Gy95iso ._1ANVC-CII7JmNj{display:flex;justify-content:flex-end;margin-top:40px}._2Ctpnw5Gy95iso ._1ANVC-CII7JmNj button{margin-left:8px}._2RzclkmErd1N71{margin-top:-12px}._2RzclkmErd1N71 ._2fVfIDXKf2Ud_B{font-size:14px;font-weight:400;display:flex}._2RzclkmErd1N71 ._2fVfIDXKf2Ud_B p{margin:0}", ""]);

// exports
exports.locals = {
	"emptyState": "_1d1KTZykDYjTsJ",
	"overlay": "_2Ctpnw5Gy95iso",
	"actions": "_1ANVC-CII7JmNj",
	"autoJoin": "_2RzclkmErd1N71",
	"autoJoinLabel": "_2fVfIDXKf2Ud_B"
};